import { useEffect, useState } from "react";
import { Globe, Save, Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AgencySettings() {
  const [agency, setAgency] = useState(null);
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/agency/me").then((r) => {
      setAgency(r.data);
      setWebsiteUrl(r.data.website_url || "");
    });
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch("/agency/me", { website_url: websiteUrl });
      toast.success("Configuração salva!");
      const { data } = await api.get("/agency/me");
      setAgency(data);
      setWebsiteUrl(data.website_url || "");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erro ao salvar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-6 lg:p-10 space-y-8 max-w-3xl" data-testid="agency-settings">
      <div>
        <div className="text-xs uppercase tracking-[0.24em] text-[#3B9EFF] font-bold">Configurações da imobiliária</div>
        <h1 className="font-heading text-3xl lg:text-4xl font-extrabold mt-1">Ajustes gerais</h1>
        {agency && (
          <p className="text-white/60 text-sm mt-2">
            {agency.name} · {agency.city}, {agency.state} · {agency.realtor_count} corretor{agency.realtor_count !== 1 ? "es" : ""}
          </p>
        )}
      </div>

      <section className="bg-[#0F1F3D] border border-white/10 rounded-2xl p-6 lg:p-8">
        <div className="flex items-start gap-4 mb-6">
          <div className="w-12 h-12 rounded-xl bg-[#3B9EFF]/15 border border-[#3B9EFF]/30 flex items-center justify-center flex-shrink-0">
            <Globe className="w-5 h-5 text-[#3B9EFF]" />
          </div>
          <div>
            <h2 className="font-heading font-bold text-lg">Site da imobiliária</h2>
            <p className="text-sm text-white/60 mt-1">
              A IA vai buscar imóveis nesse site sempre que um corretor cadastrar uma nova lead.
              Se nada bater com o perfil, ela busca no Zap Imóveis e OLX automaticamente.
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <Label htmlFor="website_url" className="text-white/80">URL do site</Label>
            <Input
              id="website_url"
              data-testid="agency-website-url"
              value={websiteUrl}
              onChange={(e) => setWebsiteUrl(e.target.value)}
              placeholder="https://donnascimoveis.com.br"
              className="!bg-white/10 !text-white !border-white/20 placeholder:!text-white/40 mt-1.5"
            />
            <p className="text-xs text-white/40 mt-1.5">Pode colar com ou sem https://. Sem barra no final.</p>
          </div>

          <Button onClick={save} disabled={saving} data-testid="save-agency-settings"
            className="bg-[#3B9EFF] hover:bg-[#1F7CE0] text-white rounded-full px-5">
            <Save className="w-4 h-4 mr-2" /> {saving ? "Salvando..." : "Salvar"}
          </Button>
        </div>

        <div className="mt-6 p-4 rounded-lg bg-[#3B9EFF]/8 border border-[#3B9EFF]/20 flex gap-3">
          <Info className="w-4 h-4 text-[#3B9EFF] flex-shrink-0 mt-0.5" />
          <div className="text-xs text-white/70 leading-relaxed">
            No piloto, o suporte da <b>Donna SC Imóveis</b> ({" "}
            <a href="https://donnascimoveis.com.br" target="_blank" rel="noreferrer" className="text-[#3B9EFF] underline">donnascimoveis.com.br</a>{" "}
            ) já está ativo. Outras imobiliárias serão adicionadas conforme necessário. Nos avise se sua estrutura de URL for diferente.
          </div>
        </div>
      </section>
    </div>
  );
}
